export default __webpack_public_path__ + "static/media/Motorola.cc43d0f3.png";